module.exports = "<div\n  class=\"error-bar\"\n  ng-class=\"{ 'visible' : vm.show }\">\n\n  <i\n    class=\"closer-absolute\"\n    ng-click=\"vm.hide()\">\n  </i>\n\n  <div\n    class=\"error-text\"\n    ng-repeat=\"error in vm.errors\">\n    <strong\n      ng-if=\"error.prefix\"\n      translate=\"{{ error.prefix }}\">\n    </strong>\n    <span translate=\"{{ error.message }}\" translate-compile></span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-error-handling/src/errorBar/errorBar.html
// module id = 1411
// module chunks = 12